import {useStaticQuery, graphql} from "gatsby"

const useJobQuery = () => {
  const {allDatoCmsJob} = useStaticQuery(graphql`
      query Job {
        allDatoCmsJob {
          nodes {
            title
            slug
            excerpt
            permalink
            location
            image {
              ...InternalAssetProps
            }
            richContent {
              value
            }
            whatWeOffer {
              value
            }
            whatYouBring {
              value
            }
            venue {
              title
              permalink
            }
            jobDescription {
              value
            }
            keyFeatures {
              title
            }
          }
        }
      }
`)

  return allDatoCmsJob.nodes
}

export default useJobQuery